import { telefonoParaMostrar } from "../../../helpers/telefonoWhatsapp";
import React from "react";
import { SPORT_LABELS } from "../../../constants/courtDomain";
import { WhatsappLink } from "../../components/Whatsapp";
import RecordatorioLineas from "../../recordatorios/RecordatorioLineas";
import { lineasDeRecordatorio } from "../../recordatorios/recordatorios";
import { plata } from "../../turnos/agenda/agendaLayout";
import OpenMatchDetailSection from "./OpenMatchDetailSection";
import { intervalHeading } from "../../turnos/agenda/turnoFijoModel";
import "../../turnos/agenda/agenda.css";
import "./CourtReservationDetail.css";

// Same wording as the payment badge of the reservations table.
const PAGO = { paid: "Seña pagada", failed: "Pago fallido" };

/*
 * Key/value box of the court reservation detail. It reuses Beauty's `ba-detalle`
 * look; rows without data are left out so a manual booking does not show empty
 * payment lines. Only presentation: the actions stay in OrgReservationsScreen.
 */
export default function CourtReservationDetailRows({ reservation, onVerSeries, onCancelOpenMatch }) {
	const r = reservation;
	const sport = r.sport ? SPORT_LABELS[r.sport] || r.sport : "";
	const deposit = r.mode === "deposit";
	const total = Number(r.totalPrice) || 0;
	// The daily grid sends `seriesIntervalWeeks` and `seriesDateTo`; other sources nest them under `series`.
	const interval = r.series?.intervalWeeks ?? r.intervalWeeks ?? r.seriesIntervalWeeks;
	const seriesEnd = r.series?.dateTo ?? r.seriesDateTo;
	const seriesEndLabel = /^\d{4}-\d{2}-\d{2}$/.test(seriesEnd || "")
		? seriesEnd.split("-").reverse().join("/")
		: "";
	const birthdayPerson =
		typeof r.birthday?.birthdayPerson === "string"
			? r.birthday.birthdayPerson.trim()
			: "";
	const hasReminders = lineasDeRecordatorio(r.reminder).length > 0;

	return (
		<>
		<dl className="ba-detalle">
			{r.courtName && (
				<>
					<dt>Cancha</dt>
					<dd>{r.courtName}</dd>
				</>
			)}
			{sport && (
				<>
					<dt>Deporte</dt>
					<dd>{sport}</dd>
				</>
			)}
			{r.seriesId && (
				<>
					<dt>Turno fijo</dt>
					<dd>
						{interval ? intervalHeading(interval) : "Se repite"}
						{seriesEndLabel && `, hasta el ${seriesEndLabel}`}
						{onVerSeries && (
							<small>
								<button
									type="button"
									className="ba-detalle__link"
									onClick={onVerSeries}
								>
									Ver turnos fijos
								</button>
							</small>
						)}
					</dd>
				</>
			)}
			{total > 0 && (
				<>
					<dt>Total</dt>
					<dd style={{ fontWeight: 600 }}>{plata(total)}</dd>
				</>
			)}
			{deposit && (
				<>
					<dt>Seña</dt>
					<dd>
						{plata(r.depositAmount)} · {PAGO[r.paymentstatus] || "Seña pendiente"}
					</dd>
				</>
			)}
			{birthdayPerson && (
				<>
					<dt>Cumpleaños</dt>
					<dd>{birthdayPerson}</dd>
				</>
			)}
			<dt>Teléfono</dt>
			<dd>
				{telefonoParaMostrar(r.phone) || "-"}
				<WhatsappLink
					phone={r.phone}
					name={r.name || ""}
					className="odcg-item-wa ba-wa-inline"
				/>
			</dd>
			{r.dni && (
				<>
					<dt>DNI</dt>
					<dd>{r.dni}</dd>
				</>
			)}
			<dt>Origen</dt>
			<dd>{r.bookingOrigin === "organizer" ? "Carga manual" : "Reserva online"}</dd>
			{hasReminders && (
				<>
					<dt>Recordatorios</dt>
					<dd>
						<RecordatorioLineas
							reminder={r.reminder}
							className="zr-recordatorios--detalle"
						/>
					</dd>
				</>
			)}
			{r.notes && (
				<>
					<dt>Notas</dt>
					<dd>{r.notes}</dd>
				</>
			)}
		</dl>
		{r.openMatch && (
			<OpenMatchDetailSection
				openMatch={r.openMatch}
				onCancel={onCancelOpenMatch}
			/>
		)}
		</>
	);
}
